module.exports = __webpack_public_path__ + "static/media/fly0255.99dd69a5.webp";